
define('txt!modules/module.slp.success.header.hbs',[],function () { return '<span class="copy">\n  <a href="#" class="success-close"><i class="icon icon-close-modal"></i></a>\n</span>\n';});

